export default __webpack_public_path__ + "static/media/pic2.3a25bc72.png";